export class IssueMutedNotificationArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "controlName",
            "baseName": "controlName",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "muted",
            "baseName": "muted",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IssueMutedNotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
